module.exports = __webpack_public_path__ + "static/media/comment-plus.384131d2.svg";